import Glide from '@glidejs/glide';

const init = () => {
  const config = {
    type: 'carousel',
    perView: 3,
    gap: 83,
    focusAt: 'center',
    breakpoints: {
      800: {
        perView: 2,
      },
      520: {
        perView: 1,
      },
    },
  };

  const glideElements = document.querySelectorAll('.glide');

  [...glideElements].forEach((item) => {
    new Glide(item, config).mount();
  });
};

// const foo = $('.karuselli');

const popup = () => {
  // eslint-disable-next-line no-undef
  $('section.karuselli').magnificPopup({
    delegate: '.glide__box',
    gallery: {
      enabled: true, // set to true to enable gallery

      preload: [0, 2], // read about this option in next Lazy-loading section

      navigateByImgClick: true,

      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

      tPrev: 'Previous (Left arrow key)', // title for left button
      tNext: 'Next (Right arrow key)', // title for right button
    },
    image: {
      markup: '<div class="mfp-figure">'
        + '<div class="mfp-close"></div>'
        + '<div class="mfp-img"></div>'
        + '<div class="mfp-bottom-bar">'
        + '<div class="mfp-title">by Marsel Van Oosten</div>'
        + '<div class="mfp-counter"></div>'
        + '</div>'
        + '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
    },
  });
};

export { init, popup };
